import NavbarTabs from "./NavbarTabs";
import "../../styles/Navbar.scss";
import { IoMdMenu } from "react-icons/io";
import { useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";

function MobileNav(){
    const [click, setClick] = useState(false);

    const Hamburger = <IoMdMenu className="hamburgernav" 
        size='40px'
        onClick={()=>setClick(!click)}
        />

    const Closebtn = <IoCloseCircleOutline
        className = "hamburgernav"
        size='40px'
        color='black'
        onClick={()=>setClick(!click)}
        />

    return(
        <>
            <nav className="mobilenav">
                {click ? Closebtn : Hamburger}
                <div className="mobilenavtabs">
                    {click && <NavbarTabs/>}{/*only shows up when hamburger clicked */}
                </div>
                
            </nav>
        </>
    );
}
export default MobileNav;